export default {
  fieldNames: {
    category: 'Categoría',
    stockType: 'Tipo de stock',
    sosUser: 'Usuario SOS',
    sosDate: 'Fecha SOS',
    minimumStock: 'Stock mínimo SOS',
    maximumStock: 'Stock máximo SOS',
    criticalitySOS: 'Criticidad SOS',
    availability: 'Disponibilidad',
    annualConsumption: 'Consumo anual',
    expenseItem: 'Elemento de Gasto',
    dangerIndex: 'Índice de peligrosidad',
    responsibleArea: 'Área responsable',
    warehouse: 'Bodega',
    criticality: 'Criticidad',
    stockQualifier: 'Calificadores de stock',
    stockQualifierSelected: 'Calificadores de stock seleccionados',
  },
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/cataloger/createNewMaterials/Stages/inventory.js